import { styled } from '@mui/system';
import theme from 'src/theme';

export const FilterContainer = styled('div')({
    display: 'flex',
    alignItems: 'flex-end',
    gap: '16px',
    flexWrap: 'wrap',
    marginBottom: '16px',
    padding: '16px 16px 0'
});

export const FilterField = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px'
});

export const filterLabelStyle = {
    color: theme.color.white50,
    fontFamily: 'Inter',
    fontSize: '12px',
    lineHeight: '12px'
};

export const DatePickerInput = styled('input')`
    border: none;
    outline: none;
    background-color: transparent;
    font-family: 'Inter';
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: ${theme.color.white90};
    min-width: 120px;
    border-bottom: 0.5px solid ${theme.color.tuna};
    padding-bottom: 12px;
    cursor: pointer;

    ::-webkit-calendar-picker-indicator {
        filter: invert(1);
        opacity: 0.5;
        cursor: pointer;
    }
`;

export const chartWrapperStyle = {
    background: theme.color.darkBlue
};
